<template>
	<div v-if="user">
		<top-widget ref="topwidget" :user="user" :isAuth="isAuth"></top-widget>

		<div class="row">
			<div class="col-md-12 col-lg-8 col-sm-12">
				<calendar @reload="reload" ref="calendar" :user="user" :isAuth="isAuth"></calendar>
			</div>

			<div v-if="user.hasRole(['manager', 'admin', 'staff', 'external_manager'])" class="col-lg-4 col-md-12 col-sm-12">
				<right-widget @reload="reload" ref="rightwidget" :user="user" :isAuth="isAuth"></right-widget>
			</div>
		</div>
	</div>
</template>

<script>
	import TopWidget from './../views/TopWidget.vue'
	import RightWidget from './../views/RightWidget.vue'
	import Calendar from './../../calendar/views/Index.vue'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'top-widget': TopWidget,
			'calendar': Calendar,
			'right-widget': RightWidget,
		},
		data () {
			return {
			}
		},
		methods: {
			reload: function() {
				this.$refs.calendar.init()
				this.$refs.topwidget.init()
				this.$refs.rightwidget.init()
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/dashboard/layout/Dashboard.vue